export default datetime => {
  return Math.floor((new Date() - new Date(datetime)) / 1000);
};
